import { Label } from '@/components/ui/label';
import { StylishNewToggleButtonGroup } from 'components/DesignSystems/New/StylishNewToggleButtonGroup';
import {
  describeEscalationPlan,
  ESCALATION_PRESET_CHOICES,
  EscalationPlan,
  EscalationPresetKey,
  escalationPlanErrors,
} from './escalationPlanModel';

type Props = {
  preset: EscalationPresetKey;
  onPresetChange: (preset: EscalationPresetKey) => void;
  plan: EscalationPlan | null;
};

/**
 * Builds the ladder a notification climbs while recipients stay silent.
 *
 * Only rendered when confirmation is requested: a cascade advances on silence,
 * and without a way to respond every step would fire for every recipient
 * regardless of whether they read the first message.
 */
const EscalationPlanField: React.FC<Props> = ({
  preset,
  onPresetChange,
  plan,
}) => {
  const errors = plan ? escalationPlanErrors(plan) : [];
  const summary = describeEscalationPlan(plan);

  return (
    <div className="mb-3">
      <Label className="form-label">If nobody responds</Label>
      <StylishNewToggleButtonGroup
        data={ESCALATION_PRESET_CHOICES}
        selected={preset}
        onChange={(value) => onPresetChange(value as EscalationPresetKey)}
        onBlur={() => {}}
      />

      {summary.length > 0 ? (
        <ul className="tw:mt-2 tw:mb-0 tw:list-none tw:space-y-0.5 tw:pl-0 tw:text-xs tw:text-muted-foreground">
          {summary.map((line, index) => (
            <li key={index}>{line}</li>
          ))}
        </ul>
      ) : null}

      {errors.length > 0 ? (
        <ul className="tw:mt-2 tw:mb-0 tw:list-none tw:space-y-0.5 tw:pl-0 tw:text-xs tw:text-destructive">
          {errors.map((error) => (
            <li key={error}>{error}</li>
          ))}
        </ul>
      ) : null}

      {preset !== 'none' ? (
        <p className="tw:mt-1 tw:mb-0 tw:text-xs tw:text-muted-foreground">
          Each step only reaches recipients who have not confirmed or replied
          yet.
        </p>
      ) : null}
    </div>
  );
};

export default EscalationPlanField;
